import TitleBlock from './TitleBlock';
import moment from 'moment';
import './print-styles.css';


export default function Page({title, children, printTitle = false}) {
  moment.updateLocale('en', {
    week: {dow: 1}
  })
  return (
    <>
      <TitleBlock title={title} printTitle={printTitle}/>
      {children}
    </>
  );
}
